import React from "react";
import { useLanguage } from "../../../../context/LanguageContext";
import useCurrency from "../../../../hooks/useCurrency";

const ShippingMethodSection = ({
  formData,
  setFormData,
  storeSettings,
  onShippingChange,
  processing,
  cart,
}) => {
  const { language } = useLanguage();
  const { formatDisplay } = useCurrency();
  // const language = "en"; // Temporary fix

  // Translations for shipping method section
  const translations = {
    en: {
      shippingMethod: "Shipping Method",
      noShippingOptions: "No shipping options available.",
    },
    ar: {
      shippingMethod: "طريقة الشحن",
      noShippingOptions: "لا توجد خيارات شحن متاحة.",
    },
  };

  const t = translations[language] || translations.en;

  const handleShippingMethodChange = (methodId) => {
    setFormData((prev) => ({ ...prev, shippingMethod: methodId }));
    // Fix: Pass only the methodId as expected by the parent component
    onShippingChange(methodId);
  };

  // Get shipping option name in current language
  const getShippingOptionName = (option) => {
    return option.multilingual?.[language]?.name || option.name || "";
  };

  // Get shipping option delivery time in current language
  const getShippingOptionDeliveryTime = (option) => {
    return (
      option.multilingual?.[language]?.deliveryTime || option.deliveryTime || ""
    );
  };

  return (
    <div className="checkout-section">
      <h2>{t.shippingMethod}</h2>

      <div className="payment-methods">
        {storeSettings.shippingOptions &&
        storeSettings.shippingOptions.length > 0 ? (
          storeSettings.shippingOptions.map((option) => (
            <div className="payment-method" key={option.id}>
              <input
                type="radio"
                id={`shipping-${option.id}`}
                name="shipping-method"
                value={option.id}
                checked={formData.shippingMethod === option.id}
                onChange={() => handleShippingMethodChange(option.id)}
                disabled={processing}
              />
              <label
                htmlFor={`shipping-${option.id}`}
                className="payment-method-label"
              >
                <div className="payment-method-main">
                  <div className="payment-details">
                    <span className="payment-title">
                      {getShippingOptionName(option)}
                    </span>
                    {getShippingOptionDeliveryTime(option) && (
                      <span className="payment-subtext">
                        {getShippingOptionDeliveryTime(option)}
                      </span>
                    )}
                  </div>
                </div>
                <div className="stripe-badges">
                  <span className="stripe-badge">
                    {formatDisplay(option.price)}
                  </span>
                </div>
              </label>
            </div>
          ))
        ) : (
          <div className="no-shipping-options">
            <p>{t.noShippingOptions}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShippingMethodSection;
